import React from "react";
import AdminVendors from "@/pages/AdminVendors";

// Phase 87 — POs / Scorecards tabs removed per founder request. Vendor
// rating now lives directly on the vendor card/row in the Directory below.
export default function VendorsHub() {
  return <AdminVendors />;
}
